import React, { useState } from "react";
import { Form } from "react-bootstrap";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  White_Linkedin,
  White_Twitter,
  White_Facebook,
  White_Instagram,
  email,
  place,
  phone,
  follow_Icon,
} from "../../controller/image";
import Style from "./ContactUs.module.css";
import { ContactData } from "../../controller/ContactData";
import Inputs from "../../components/Inputs/CustomizInput";
import CustomizButton from "../../components/buttons/CustomizButton";
import CustomModal from "../../components/reusablemodal/CustomModal";
import { AxiosInstance } from "../../axios";

const generateCaptcha = () => {
  const chars =
    "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let captcha = "";
  for (let i = 0; i < 6; i++) {
    captcha += chars[Math.floor(Math.random() * chars.length)];
  }
  return captcha;
};

// ❌ Disallowed patterns
const specialCharRegex = /[!@#$%^&*(){}_+":<>?/.,';\][\\]/;
const emojiRegex =
  /([\u203C-\u3299]|[\uD83C-\uDBFF\uDC00-\uDFFF]+|\p{Extended_Pictographic})/gu;

function ContactUs() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
    captcha: "",
  });

  const [errors, setErrors] = useState({});
  const [captchaText, setCaptchaText] = useState(generateCaptcha());
  const [showModal, setShowModal] = useState(false);

  // ✅ Clear error on change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  // ✅ Validation Logic
  const validateForm = () => {
    const newErrors = {};

    // First Name
    if (!formData.firstName) {
      newErrors.firstName = "First Name is required.";
    } else if (formData.firstName.length < 3) {
      newErrors.firstName = "First Name must be at least 3 characters.";
    } else if (formData.firstName.length > 75) {
      newErrors.firstName = "Maximum 75 characters allowed.";
    } else if (specialCharRegex.test(formData.firstName)) {
      newErrors.firstName = "Special characters are not allowed.";
    } else if (emojiRegex.test(formData.firstName)) {
      newErrors.firstName = "Emojis are not allowed.";
    }

    // Last Name
    if (!formData.lastName) {
      newErrors.lastName = "Last Name is required.";
    } else if (formData.lastName.length > 75) {
      newErrors.lastName = "Maximum 75 characters allowed.";
    } else if (specialCharRegex.test(formData.lastName)) {
      newErrors.lastName = "Special characters are not allowed.";
    } else if (emojiRegex.test(formData.lastName)) {
      newErrors.lastName = "Emojis are not allowed.";
    }

    // Email
    if (!formData.email) {
      newErrors.email = "Email Address is required.";
    } else if (formData.email.length > 150) {
      newErrors.email = "Maximum 150 characters allowed.";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    ) {
      newErrors.email = "Enter a valid email address.";
    } else if (emojiRegex.test(formData.email)) {
      newErrors.email = "Emojis are not allowed.";
    }

    // Phone
    if (!formData.phone) {
      newErrors.phone = "Phone Number is required.";
    } else if (!/^\d+$/.test(formData.phone)) {
      newErrors.phone = "Phone Number must contain digits only.";
    } else if (formData.phone.length < 8) {
      newErrors.phone = "Phone Number must be at least 8 digits.";
    } else if (formData.phone.length > 15) {
      newErrors.phone = "Maximum 15 digits allowed.";
    } else if (emojiRegex.test(formData.phone)) {
      newErrors.phone = "Emojis are not allowed.";
    }

    // Subject
    if (!formData.subject) {
      newErrors.subject = "Subject is required.";
    } else if (formData.subject.length > 250) {
      newErrors.subject = "Maximum 250 characters allowed.";
    } else if (specialCharRegex.test(formData.subject)) {
      newErrors.subject = "Special characters are not allowed.";
    } else if (emojiRegex.test(formData.subject)) {
      newErrors.subject = "Emojis are not allowed.";
    }

    // Message
    if (!formData.message) {
      newErrors.message = "Message is required.";
    } else if (formData.message.length > 5000) {
      newErrors.message = "Maximum 5000 characters allowed.";
    } else if (emojiRegex.test(formData.message)) {
      newErrors.message = "Emojis are not allowed.";
    }

    // Captcha
    if (!formData.captcha) {
      newErrors.captcha = "Verification code is required.";
    } else if (formData.captcha !== captchaText) {
      newErrors.captcha = "Invalid verification code.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ✅ Submit Handler
  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   if (validateForm()) {
  //     setToast({
  //       show: true,
  //       message: "Form submitted successfully (UI only).",
  //       variant: "success",
  //     });
  //     setFormData({
  //       firstName: "",
  //       lastName: "",
  //       email: "",
  //       phone: "",
  //       subject: "",
  //       message: "",
  //       captcha: "",
  //     });
  //     setCaptchaText(generateCaptcha());
  //   }
  // };
  // ✅ Submit Handler
  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!validateForm()) return;

  //   try {
  //     // Prepare payload as per API requirement
  //     const payload = {
  //       first_name: formData.firstName,
  //       last_name: formData.lastName,
  //       email_address: formData.email,
  //       phone_number: formData.phone,
  //       subject: formData.subject,
  //       message: formData.message,
  //     };

  //     // ✅ API Call
  //     const response = await fetch(
  //       "https://dev.holybharat.com/api/contact_us/create_contactus",
  //     );

  //     const data = await response.json();

  //     if (data?.status === true) {
  //       // ✅ Success
  //       setToast({
  //         show: true,
  //         message: "Message sent successfully!",
  //         variant: "success",
  //       });

  //       // Reset form & captcha
  //       setFormData({
  //         firstName: "",
  //         lastName: "",
  //         email: "",
  //         phone: "",
  //         subject: "",
  //         message: "",
  //         captcha: "",
  //       });
  //       setCaptchaText(generateCaptcha());
  //     } else {
  //       // ❌ Failure
  //       setToast({
  //         show: true,
  //         message:
  //           data?.message || "Failed to send your message. Please try again.",
  //         variant: "danger",
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error submitting form:", error);
  //     setToast({
  //       show: true,
  //       message: "Something went wrong. Please try again later.",
  //       variant: "danger",
  //     });
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      // Prepare payload as per API requirement
      const payload = {
        first_name: formData.firstName,
        last_name: formData.lastName,
        email_address: formData.email,
        phone_number: formData.phone,
        subject: formData.subject,
        message: formData.message,
      };

      // ✅ API Call using AxiosInstance
      const response = await AxiosInstance.post(
        "/contact_us/create_contactus",
        payload
      );

      if (response?.data?.status === true) {
        // ✅ Show Custom Modal on success
        setShowModal(true);

        // Reset form & captcha
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
          captcha: "",
        });
        setCaptchaText(generateCaptcha());
      } else {
        // ❌ Failure
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <div className={`container-fluid p-3 p-md-5 mb-4 ${Style.main_div}`}>
      <div className="row">
        {/* Right Column: Form */}
        <div className="col-12 col-md-7 order-1 order-md-2 ">
          <div className={`card p-4 shadow ${Style.Custom_Card}`}>
            <h5 className={`mb-3 cardTitle`}>
              Fill out the form below and we'll get back to you soon.
            </h5>

            <form onSubmit={handleSubmit}>
              <div className="row mb-0">
                <div className="col-md-6 px-2">
                  <Inputs
                    label="First Name"
                    type="text"
                    name="firstName"
                    placeholder="Enter your First Name"
                    value={formData.firstName}
                    onChange={handleChange}
                    error={errors.firstName}
                  />
                </div>
                <div className="col-md-6 px-2">
                  <Inputs
                    label="Last Name"
                    type="text"
                    name="lastName"
                    placeholder="Enter your Last Name"
                    value={formData.lastName}
                    onChange={handleChange}
                    error={errors.lastName}
                  />
                </div>
              </div>

              <div className="row mb-0">
                <div className="col-md-6 px-2">
                  <Inputs
                    label="Email Address"
                    type="email"
                    name="email"
                    placeholder="Enter email address"
                    value={formData.email}
                    onChange={handleChange}
                    error={errors.email}
                  />
                </div>
                <div className="col-md-6 px-2">
                  <Inputs
                    label="Phone Number"
                    name="phone"
                    type="text"
                    placeholder="Enter phone number"
                    value={formData.phone}
                    onChange={handleChange}
                    error={errors.phone}
                  />
                </div>
              </div>

              <div className="row mb-0">
                <div className="col-12 px-2">
                  <Inputs
                    label="Subject"
                    name="subject"
                    type="text"
                    placeholder="Enter subject"
                    value={formData.subject}
                    onChange={handleChange}
                    error={errors.subject}
                  />
                </div>
              </div>

              <div className="row mb-0">
                <div className="col-12 px-2">
                  <Inputs
                    label="Message / Description"
                    name="message"
                    type="textarea"
                    placeholder="Briefly tell us about your needs..."
                    value={formData.message}
                    onChange={handleChange}
                    error={errors.message}
                  />
                </div>
              </div>

              <div className="row mb-0">
                <div className="col-md-12 mb-2 px-2">
                  <div
                    className={`${Style.captchaWrapper} d-flex align-items-center gap-2`}
                  >
                    <Inputs
                      label="Verification Code"
                      type="text"
                      name="captcha"
                      placeholder="Enter the CAPTCHA code"
                      value={formData.captcha}
                      onChange={handleChange}
                      error={errors.captcha}
                    />
                    <div
                      className={`${Style.captchaContent} d-flex align-items-center gap-2`}
                    >
                      <span className={Style.captchaText}>{captchaText}</span>
                      <span
                        className={Style.refreshIcon}
                        onClick={() => setCaptchaText(generateCaptcha())}
                        role="button"
                        tabIndex={0}
                      >
                        <RefreshIcon
                          style={{ color: "#FA840E", cursor: "pointer" }}
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row d-flex align-items-center mt-3 px-2">
                <div className="col-12 col-md-9 mb-3 mb-md-0">
                  <span style={{ color: "#142454", fontSize: "14px" }}>
                    By submitting this form, you accept the privacy policy of
                    our site.
                  </span>
                </div>
                <div className="col-12 col-md-3">
                  <CustomizButton
                    type="submit"
                    label="Let’s Connect"
                    maxWidth="100%"
                    width="100%"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* Left Column: Contact Info */}
        <div className="col-12 col-md-5 mb-4 mb-md-0 order-2 order-md-1">
          <h5 className={`main_heading ${Style.contact_heading}`}>
            Connect with Holy Bharat
          </h5>
          <div className="mt-4 d-flex align-items-center">
            <img src={email} alt="email" height="30" className="me-3" />
            <div className="d-flex flex-column justify-content-center">
              <div className={Style.contact_title}>Chat with us</div>
              <p className={`mb-0 ${Style.contact_text}`}>
                {ContactData[0]?.text}
              </p>
            </div>
          </div>

          {/* <ModalComponent
            show={open}
            onHide={() => setOpen(false)}
            title="Submitted Successfully"
            bodyText="Thank you for your interest in Bharat Clouds. Your message is valuable to us, and we will ensure it reaches the team best suited to help you. We will get back to you shortly."
            buttontext="OK"
          /> */}

          <div className="mt-4 d-flex align-items-center">
            <img src={place} alt="location" height="40" className="me-3" />
            <div className="d-flex flex-column justify-content-center">
              <div className={Style.contact_title}>Visit us</div>
              <p className={`mb-0 ${Style.contact_text}`}>
                {ContactData[2]?.text}
              </p>
            </div>
          </div>
          <div className="mt-4 d-flex align-items-center">
            <img src={phone} alt="phone" height="30" className="me-3" />
            <div className="d-flex flex-column justify-content-center">
              <div className={Style.contact_title}>Call us</div>
              <p className={`mb-0 ${Style.contact_text}`}>
                {ContactData[1]?.text}
              </p>
            </div>
          </div>
          <div className="mt-4 d-flex align-items-center">
            <img src={follow_Icon} alt="phone" height="30" className="me-3" />
            <div className="d-flex flex-column justify-content-center">
              <div className={Style.contact_title}>Follow us</div>
              <ul className="list-unstyled d-flex gap-3 m-0">
                <li>
                  <a
                    href="https://www.linkedin.com/in/holy-bharat-1739b838a/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={White_Linkedin} alt="linkedin Icon" height="20" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://x.com/HolyBharat"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={White_Twitter} alt="twitter Icon" height="20" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/holybharat"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={White_Facebook} alt="facebook Icon" height="20" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/holy.bharat/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={White_Instagram}
                      alt="Instagram Icon"
                      height="20"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <CustomModal
        show={showModal}
        title="Enquiry Submitted"
        primaryButtonLable="Ok"
        primaryClick={() => setShowModal(false)} // close modal on OK click
        renderModalContent={
          <p>
            Thank you for reaching out to Holy Bharat. Your enquiry has been
            received successfully. Our team will get in touch with you soon.
          </p>
        }
      />
    </div>
  );
}

export default ContactUs;
